import React, { useEffect, useRef, useState } from "react";

// Les fractions (marge, gestion, remise) se saisissent en pourcentage ou en coefficient,
// comme dans le tableur ; elles sont stockées en fraction.
const FIELDS = [
  { field: "hourly_rate", label: "Coût horaire", suffix: "€/h", scale: 1 },
  { field: "hours_per_day", label: "Heures par jour", suffix: "h", scale: 1 },
  { field: "material_margin", label: "Coef. marge matériel", suffix: "", scale: 1, help: "Achats ÷ coefficient" },
  { field: "pm_rate", label: "Gestion de projet", suffix: "%", scale: 100 },
  { field: "client_discount", label: "Remise client", suffix: "%", scale: 100 },
];

const Field = ({ spec, value, onChange, disabled }) => {
  const display = (v) => String(Math.round(Number(v || 0) * spec.scale * 1000) / 1000).replace(".", ",");
  const [text, setText] = useState(display(value));
  const focused = useRef(false);
  useEffect(() => {
    if (!focused.current) setText(display(value));
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <label className="block text-xs font-medium text-slate-500" title={spec.help}>
      {spec.label}
      <span className="mt-1 flex items-center rounded-lg border border-slate-300 bg-white px-2 focus-within:border-blue-400">
        <input
          type="text"
          inputMode="decimal"
          disabled={disabled}
          value={text}
          onFocus={() => { focused.current = true; }}
          onBlur={() => { focused.current = false; setText(display(value)); }}
          onChange={(event) => {
            setText(event.target.value);
            const parsed = Number(event.target.value.replace(",", "."));
            if (event.target.value.trim() !== "" && Number.isFinite(parsed)) onChange(spec.field, parsed / spec.scale);
          }}
          className="w-full min-w-0 bg-transparent py-1.5 text-right text-sm tabular-nums text-slate-900 focus:outline-none"
        />
        {spec.suffix && <span className="pl-1 text-xs text-slate-400">{spec.suffix}</span>}
      </span>
    </label>
  );
};

const ParamsFields = ({ params, onChange, disabled, compact }) => (
  <div className={`grid gap-3 ${compact ? "grid-cols-2" : "grid-cols-2 md:grid-cols-5"}`}>
    {FIELDS.map((spec) => (
      <Field key={spec.field} spec={spec} value={params?.[spec.field]} disabled={disabled} onChange={onChange} />
    ))}
  </div>
);

export default ParamsFields;
